import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.policies.password-authentication-policy', {
        url: '/password-authentication-policy',
        component: 'passwordAuthenticationPolicy',
        resolve: {companyPasswordPolicies,defaultPolicy},
    });
}

/** @ngInject */
function companyPasswordPolicies(companyId,PasswordAuthenticationPoliciesService) {
    return PasswordAuthenticationPoliciesService.getPasswordPolicyList(companyId);
}
/** @ngInject */
function defaultPolicy(AuthenticationAccessPolicyResource, companyId, companyPasswordPolicies) {
    return companyPasswordPolicies.find(policy => policy.passwordPolicyName === 'Default Policy');
}


// WEBPACK FOOTER //
// ./src/portal/states/company/policies/password-authentication-policy/password-authentication-policy.state.js